'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {
    IndustriesCardsBlockSlider
} from "@/app/[locale]/common/components/IndustriesCardsBlockSlider/IndustriesCardsBlockSlider";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import Image from "next/image";
import monitoring_services_top
    from "@/app/[locale]/common/assets/images/services/monitoring-services/monitoring-services.webp";
import {Button} from "@/app/[locale]/common/components/Button/Button";
import {TServicesCardsContent, TServicesCardsContentIcon} from "@/app/[locale]/services/types";
import {ModalWindow} from "@/app/[locale]/common/components/ModalWindow/ModalWindow";
import {useState} from "react";
import {
    ContactUsModalWindowContent
} from "@/app/[locale]/common/components/ContactUsModalWindowContent/ContactUsModalWindowContent";
import {useTranslations} from "next-intl";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {TimeTrackingIcon} from "@/app/[locale]/common/assets/TimeTrackingIcon/TimeTrackingIcon";
import {AlertIcon} from "@/app/[locale]/common/assets/AlertIcon/AlertIcon";
import {TabletIcon} from "@/app/[locale]/common/assets/TabletIcon/TabletIcon";
import {DataMonitoringIcon} from "@/app/[locale]/common/assets/DataMonitoringIcon/DataMonitoringIcon";
import {NumOneCircleIcon} from "@/app/[locale]/common/assets/NumOneCircleIcon/NumOneCircleIcon";
import {NumTwoCircleIcon} from "@/app/[locale]/common/assets/NumTwoCircleIcon/NumTwoCircleIcon";
import {NumTreeCircleIcon} from "@/app/[locale]/common/assets/NumTreeCircleIcon/NumTreeCircleIcon";
import {NumFourCircleIcon} from "@/app/[locale]/common/assets/NumFourCircleIcon/NumFourCircleIcon";
import {NumFiveCircleIcon} from "@/app/[locale]/common/assets/NumFiveCircleIcon/NumFiveCircleIcon";

export default function MonitoringServicesPage() {
    const t = useTranslations('MonitoringServicesPage');
    const keyFeatureBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('keyFeatureBlock.cardsData'), [TimeTrackingIcon, AlertIcon, TabletIcon, DataMonitoringIcon], 'Icon');
    const subscriptionBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('subscriptionBlock.cardsData'), [NumOneCircleIcon, NumTwoCircleIcon, NumTreeCircleIcon, NumFourCircleIcon], 'Icon');
    const aboutBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('aboutBlock.cardsData'), [NumOneCircleIcon, NumTwoCircleIcon, NumTreeCircleIcon, NumFourCircleIcon, NumFiveCircleIcon], 'Icon');

    const [ isOpenModalWindow, setIsOpenModalWindow ] = useState(false);
    const openModalWindow = () => setIsOpenModalWindow(true);
    const closeModalWindow = () => setIsOpenModalWindow(false);

    return (
        <div className={s.monitoringServices}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.SERVICES'), t.raw('breadcrumbs.MONITORING_SERVICES')]} />

                <div className={s.monitoringServices_top}>
                    <Title title={t('title')} />

                    <div className={s.monitoringServices_flexContainer}>
                        <div className={s.monitoringServices_imageContainer}>
                            <Image src={monitoring_services_top} alt={'monitoring_services_top'}/>
                        </div>

                        <div className={s.monitoringServices_top_content}>
                            <p className={s.monitoringServices_text} dangerouslySetInnerHTML={{__html: t.raw('topBlock.firstText')}} />
                            <p className={s.monitoringServices_text} dangerouslySetInnerHTML={{__html: t.raw('topBlock.secondText')}}/>
                            <Button size={'medium'} onClick={openModalWindow}>{t('topBlock.button')}</Button>
                        </div>
                    </div>
                </div>

                <div className={s.monitoringServices_onlineMonitoring}>
                    <Title title={t('onlineMonitoringBlock.title')} />
                    <div className={`${s.monitoringServices_flexContainer} ${s.monitoringServices_onlineMonitoring_flexContainer}`}>
                        {
                            t.raw('onlineMonitoringBlock.list').map((item: string, index: number) => (
                                <p key={index}>
                                    { item }
                                </p>
                            ))
                        }
                    </div>
                </div>
                
                <div className={s.monitoringServices_fuelMonitoring}>
                    <Title title={t('fuelMonitoring.title')} />
                    <p className={`${s.monitoringServices_text} ${s.monitoringServices_textBlock}`}>{ t('fuelMonitoring.text') }</p>

                    <div className={s.monitoringServices_gridContainer}>
                        {
                            t.raw('fuelMonitoring.cardsData').map(( item: TServicesCardsContent, index: number) => (
                                <div key={index} className={`${s.monitoringServices_card} ${s.monitoringServices_fuelMonitoring_card}`}>
                                    <label className={s.monitoringServices_label}>{ item.label }</label>
                                    <p className={s.monitoringServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.monitoringServices_keyFeature}>
                    <Title title={t('keyFeatureBlock.title')} />

                    <div className={s.monitoringServices_gridContainer}>
                        {
                            keyFeatureBlockCardsData.map((item: TServicesCardsContentIcon, index: number ) => (
                                <div key={index} className={s.monitoringServices_card}>
                                    <div className={s.monitoringServices_keyFeature_iconContainer}>
                                        { <item.Icon /> }
                                    </div>
                                    <label className={s.monitoringServices_label}>{ item.label }</label>
                                    <p className={s.monitoringServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.monitoringServices_subscription}>
                    <Title title={t('subscriptionBlock.title')} />
                    <p className={`${s.monitoringServices_text} ${s.monitoringServices_textBlock}`}>
                        { t('subscriptionBlock.text') }
                    </p>

                    <div className={s.monitoringServices_subscription_cardsContainer}>
                        {
                            subscriptionBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index} className={`${s.monitoringServices_card} ${s.monitoringServices_subscription_card}`}>
                                    <div className={s.monitoringServices_iconContainer}>{ <item.Icon />}</div>
                                    <label>{ item.label }</label>
                                    <p className={s.monitoringServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <IndustriesCardsBlockSlider
                    title={t('industriesBlock.title')}
                    text={t('industriesBlock.text')}
                    data={t.raw('industriesBlock.cardsData')}
                />

                <div className={s.monitoringServices_about}>
                    <Title title={t('aboutBlock.title')} />

                    <div className={s.monitoringServices_about_cardsContainer}>
                        {
                            aboutBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index} className={`${s.monitoringServices_card} ${s.monitoringServices_about_card}`}>
                                    <div className={s.monitoringServices_iconContainer}>
                                        { <item.Icon /> }
                                    </div>

                                    <label>{ item.label }</label>
                                    <p className={s.monitoringServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <Title title={t('contacts.title')}/>
                <p className={`${s.monitoringServices_text} ${s.monitoringServices_textBlock}`}>{t('contacts.text')}</p>
                <ContactUs title={false}/>

                <ModalWindow isOpen={isOpenModalWindow} closeModalWindow={closeModalWindow}>
                    <ContactUsModalWindowContent />
                </ModalWindow>
            </Container>
        </div>
    );
};